module.exports = __webpack_public_path__ + "flowdock-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/flowdock-logo.png
// module id = 1254
// module chunks = 74